import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export const EI_STATUS = {
  null: ["Bozza", "neutral"], sent: ["Inviata allo SDI", "blue"], attempt: ["In invio", "blue"], pending: ["In attesa SDI", "blue"], processing: ["In elaborazione", "blue"],
  delivered: ["Consegnata", "green"], accepted: ["Accettata", "green"], manual_accepted: ["Accettata", "green"], no_response: ["Decorrenza termini", "green"],
  not_delivered: ["Mancata consegna", "amber"], error: ["Errore", "red"], discarded: ["Scartata", "red"], rejected: ["Rifiutata", "red"], refused: ["Rifiutata", "red"],
};
export const eiStatus = (s) => EI_STATUS[s] || [s, "neutral"];

export const PAY_STATUS = { pagata: ["Pagata", "green"], da_incassare: ["Da incassare", "amber"], scaduta: ["Scaduta", "red"] };
export const payLabel = (inv) => (inv.status !== "inviata" || !inv.payment_status ? null
  : inv.payment_status === "scaduta" ? `Scaduta da ${inv.overdue_days} gg` : PAY_STATUS[inv.payment_status][0]);

export const openInvoicePdf = async (inv) => {
  try {
    const r = await api.get(`/fic/invoices/${inv.id}/pdf`, { responseType: "blob" });
    window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
  } catch (e) { toast.error(errorMessage(e)); }
};
